module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/features/ribbon/ribbon-style-3/ribbon-style-3.component.scss
// module id = ./src/app/features/ribbon/ribbon-style-3/ribbon-style-3.component.scss
// module chunks = main